import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetUsersStatisticsResData } from "./GetUsersStatisticsResData";

const ENDPOINT = "/usermanagement/stats";

export class GetUsersStatisticsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetUsersStatisticsResData> {
        let res = await this.executeCommand();
        return new GetUsersStatisticsResData(res);
    }
}
